<template>
  <v-col cols="12">
    <v-toolbar color="grey lighten-3">
      <v-toolbar-title>Sums</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn small fab color="primary" @click="onAddSum">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <v-expansion-panels focusable>
      <draggable
        v-model="sumList"
        @start="drag = true"
        @end="
          drag = false;
          onDragSumEnd($event);
        "
        handle=".draghandle"
        style="width: 100%"
      >
        <transition-group>
          <v-expansion-panel v-for="(sum, index) in sumList" :key="sum.id">
            <v-expansion-panel-header color="grey lighten-5">
              <template v-slot:default="{ open }">
                <v-fade-transition leave-absolute>
                  <v-row no-gutters align="center">
                    <v-col>
                      <v-btn icon class="draghandle">
                        <v-icon>mdi-drag-horizontal</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col cols="2">
                      <span v-if="open" key="0"> {{ sum.name.defaultValue.value }} </span>
                      <span v-else key="1"> {{ sum.name.defaultValue.value }} </span>
                    </v-col>

                    <v-col cols="6">
                      <v-select v-model="sum.series" :items="series" item-text="name.defaultValue" item-value="id" multiple chips disabled height="0" append-icon="" class="withoutline">
                        <template #selection="{ item }">
                          <v-chip small color="primary">{{ item.name.defaultValue.value }}</v-chip>
                        </template>
                      </v-select>
                    </v-col>
                    <v-spacer> </v-spacer>
                    <v-col cols="2">
                      <v-chip v-if="sum.type == 'INGOING_SUM_TOTAL'" small color="inverted"> INGOING </v-chip>
                      <v-chip v-if="sum.type == 'SUB_SERIES_TOTAL'" small color="inverted"> SUB-SERIES </v-chip>
                      <v-chip v-if="sum.type == 'SERIES_TOTAL'" small color="inverted"> SERIES </v-chip>
                      <v-chip v-if="sum.type == 'SUB_TOTAL'" small color="secondary"> SUB-TOTAL </v-chip>
                      <v-chip v-if="sum.type == 'TOTAL'" small color="primary"> TOTAL </v-chip>
                    </v-col>

                    <v-col cols="1">
                      <v-btn icon>
                        <v-icon @click="onDeleteSum(sum.id, index)">mdi-close-thick</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-fade-transition>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-container>
                <v-row>
                  <v-col cols="3">
                    <v-subheader>Type</v-subheader>
                    <v-radio-group v-model="sum.type" mandatory class="shrink ma-0 ma-0">
                      <v-radio label="Ingoing" value="INGOING_SUM_TOTAL"></v-radio>
                      <v-radio label="Sub series" value="SUB_SERIES_TOTAL"></v-radio>
                      <v-radio label="Series" value="SERIES_TOTAL"></v-radio>
                      <v-radio label="Sub total" value="SUB_TOTAL"></v-radio>
                      <v-radio label="Total" value="TOTAL"> </v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="7">
                    <v-text-field v-model="sum.name.defaultValue.value" label="Name" placeholder="Sum name"></v-text-field>

                    <div class="grey--text text-caption" v-if="sum.type == 'SUB_SERIES_TOTAL'">To and from shots</div>
                    <div v-if="sum.type == 'SUB_SERIES_TOTAL'" style="display: flex; flex-direction: row; justify-content: center; align-items: center; width: 20%">
                      <v-text-field label="From" min="1" :value="getShotNumber('FROM', index)" @click="onFromShot($event, index)" type="number"></v-text-field>

                      <v-text-field style="margin-left: 20px" min="1" label="To" type="number" :value="getShotNumber('TO', index)" @click="onToShot($event, index)"></v-text-field>
                      <!-- :value="getShotNumber('TO', index)" -->
                      <!-- @click="onToShot($event, index)" -->
                    </div>
                    <v-autocomplete
                      label="Series"
                      v-if="sum.type !== 'INGOING_SUM_TOTAL'"
                      v-model="sum.series"
                      :items="series"
                      item-text="name.defaultValue.value"
                      item-value="id"
                      multiple
                      chips
                      deletable-chips
                    ></v-autocomplete>
                    <v-autocomplete
                      label="Ingoing sum"
                      v-if="sum.type !== 'INGOING_SUM_TOTAL'"
                      v-model="sum.ingoingSumId"
                      :items="ingoingSums"
                      item-text="name.defaultValue.value"
                      item-value="id"
                      chips
                      deletable-chips
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="2">
                    <v-text-field v-model.number="sum.numberOfDecimals" label="Decimal count" type="number"></v-text-field>
                    <v-checkbox v-model="sum.innerHitCount" label="Count inner hits"></v-checkbox>
                    <v-radio-group v-model="sum.scoreType" mandatory class="shrink ma-0 ma-0">
                      <v-radio label="Points" value="SCORE_POINTS"></v-radio>
                      <v-radio label="Points and time" value="SCORE_POINTS_AND_TIME"></v-radio>
                      <v-radio label="Hit and Hit Factor" value="SCORE_HIT_AND_HIT_FACTOR"></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </transition-group>
      </draggable>
    </v-expansion-panels>

    <!-- SUm sumSequences  -->
    <p></p>
    <v-toolbar color="grey lighten-3">
      <v-toolbar-title>Sum sequences</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn small fab color="primary" @click="onAddSumSequence">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>
    <v-expansion-panels focusable>
      <draggable
        v-model="sequenceList"
        @start="drag = true"
        @end="
          drag = false;
          onDragSequenceEnd();
        "
        handle=".draghandle"
        style="width: 100%"
      >
        <transition-group>
          <v-expansion-panel v-for="sumSequence in sequenceList" :key="sumSequence.id">
            <v-expansion-panel-header color="grey lighten-5">
              <template v-slot:default="{ open }">
                <v-fade-transition leave-absolute>
                  <v-row no-gutters align="center">
                    <v-col>
                      <v-btn icon class="draghandle">
                        <v-icon>mdi-drag-horizontal</v-icon>
                      </v-btn>
                    </v-col>
                    <v-col cols="2">
                      <span v-if="open" key="0">
                        {{ sumSequence.name.defaultValue.value }}
                      </span>
                      <span v-else key="1">
                        {{ sumSequence.name.defaultValue.value }}
                      </span>
                    </v-col>
                    <v-col cols="8">
                      <v-select v-model="sumSequence.sumIds" :items="sumList" item-text="name.defaultValue.value" item-value="id" multiple chips disabled height="0" append-icon="" class="withoutline">
                        <template #selection="{ item }">
                          <v-chip small color="primary">{{ item.name.defaultValue.value }} </v-chip>
                        </template>
                      </v-select>
                    </v-col>

                    <v-spacer> </v-spacer>
                    <v-col cols="1">
                      <v-btn icon>
                        <v-icon @click="onDeleteSumSequence(sumSequence.id)">mdi-close-thick</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-fade-transition>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-text-field v-model="sumSequence.name.defaultValue.value" label="Name" placeholder="Sum sequence name"></v-text-field>

              <v-autocomplete v-model="sumSequence.sumIds" :items="sumList" item-text="name.defaultValue.value" item-value="id" multiple chips deletable-chips></v-autocomplete>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </transition-group>
      </draggable>
    </v-expansion-panels>
  </v-col>
</template>

<script>
  import { v4 as uuidv4 } from 'uuid';
  import draggable from 'vuedraggable';

  export default {
    name: 'EditSumsPanel',
    props: {
      series: Array,
      sums: {
        default: () => [],
        type: Array,
      },
      sumSequences: {
        default: () => [],
        type: Array,
      },
    },
    data: () => ({
      sumList: [],
      sequenceList: [],
      toFromShotList: [],
      shotType: { FROM: 'from', TO: 'to' },
    }),

    watch: {
      sums: function (newVal) {
        if (newVal.length != this.sumList.length) this.sumList = newVal;
      },
      sumSequences: function (newVal) {
        if (newVal.length != this.sequenceList.length) this.sequenceList = newVal;
      },
    },
    components: {
      draggable,
    },
    created() {
      this.sumList = this.sums;
      this.sequenceList = this.sumSequences;
      for (let sum = 0; sum < this.sumList.length; sum++) {
        if (this.sumList[sum].series.length != 0)
          if (this.sumList[sum].series[0].shots != null) {
            this.toFromShotList[sum] = { from: null, to: null };
            this.toFromShotList[sum].from = this.sumList[sum].series[0].shots.from + 1;
            this.toFromShotList[sum].to = this.sumList[sum].series[0].shots.to + 1;
          }
      }

      this.$emit('onToFromShot', this.toFromShotList);
    },
    methods: {
      getShotNumber(type, index) {
        if (this.toFromShotList[index] != null && this.sums[index].type == 'SUB_SERIES_TOTAL') {
          if (type == 'FROM') {
            return String(this.toFromShotList[index].from);
          } else {
            return String(this.toFromShotList[index].to);
          }
        } else return null;
      },
      onFromShot(event, index) {
        let fromShot = event.srcElement.value;

        if (this.toFromShotList[index] == undefined || this.toFromShotList[index] == null) this.toFromShotList[index] = { from: null, to: null };

        this.toFromShotList[index].from = parseInt(fromShot);
        this.$emit('onToFromShot', this.toFromShotList);
      },

      onToShot(event, index) {
        let toShot = event.srcElement.value;

        if (this.toFromShotList[index] == undefined || this.toFromShotList[index] == null) this.toFromShotList[index] = { from: null, to: null };

        this.toFromShotList[index].to = parseInt(toShot);
        this.$emit('onToFromShot', this.toFromShotList);
      },

      onAddSum() {
        this.sums.push({
          id: uuidv4(),
          innerHitCount: false,
          name: {
            defaultValue: {
              value: 'New sum',
              languages: [],
            },
            profileValues: [],
          },
          numberOfDecimals: 0,
          scoreType: 'SCORE_POINTS',
          series: [],
          type: 'SERIES_TOTAL',
        });
      },

      onDeleteSum(id, index) {
        let newShotArray = [];
        for (let i = 0; i < this.toFromShotList.length; i++) {
          if (i != index) newShotArray.push(this.toFromShotList[i]);
        }

        this.toFromShotList = newShotArray;
        this.$emit('onToFromShot', this.toFromShotList);
        this.$emit('onDeleteSum', id);
      },

      onDragSumEnd(event) {
        let sumIdList = [];
        const newIndex = event.newIndex;
        const oldIndex = event.oldIndex;
        let dragArraySub = [];

        let copySubType = this.toFromShotList[oldIndex];

        for (let i = 0; i < this.sumList.length; i++) {
          if (i != oldIndex) dragArraySub.push(this.toFromShotList[i]);
        }

        //Order toFromShotList in accordance with new order of sums
        dragArraySub.splice(newIndex, 0, copySubType);

        this.toFromShotList = dragArraySub;
        for (let sum = 0; sum < this.sumList.length; sum++) {
          let from = null;
          let to = null;

          if (this.toFromShotList[sum] != null) {
            if (this.toFromShotList[sum].from != null) from = this.toFromShotList[sum].from;
            if (this.toFromShotList[sum].to != null) to = this.toFromShotList[sum].to;

            if (this.sumList[sum].series[0].id == undefined) {
              this.sumList[sum].series[0] = { id: this.sumList[sum].series[0], shots: { from: null, to: null } };
            }

            if (from != null) this.sumList[sum].series[0].shots.from = from;
            if (to != null) this.sumList[sum].series[0].shots.to = to;
          }
        }

        this.$emit('onToFromShot', this.toFromShotList);
        this.$emit('onDragSumEnd', this.sumList);

        //Sort all the sequence lists to reflect the sum order.
        for (let sequence of this.sequenceList) {
          for (let sum of this.sumList) {
            for (let sumIdOfSeq of sequence.sumIds) {
              if (sum.id == sumIdOfSeq) {
                sumIdList.push(sumIdOfSeq);
                break;
              }
            }
          }

          let index = this.sequenceList.indexOf(sequence);
          this.sequenceList[index].sumIds = sumIdList;
          sumIdList = [];
        }
      },

      onDragSequenceEnd() {
        this.$emit('onDragSequenceEnd', this.sequenceList);
      },

      onAddSumSequence() {
        this.sumSequences.push({
          id: uuidv4(),
          name: {
            defaultValue: {
              value: 'New sum sequence',
              languages: [],
            },
            profileValues: [],
          },
          sumIds: [],
        });
      },
      onDeleteSumSequence(id) {
        this.$emit('onDeleteSumSequence', id);
      },
    },
    computed: {
      ingoingSums() {
        return this.sums.filter((s) => s.type === 'INGOING_SUM_TOTAL');
      },
    },
  };
</script>
